<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Items from '../components/Items.svelte'; 
    import MenuItems from '../components/MenuItems2.svelte';
    import { add_location } from 'svelte/internal';

   
    let menuItems = [];
    let menuItems_nested = [];
    let categories = [] 
    let categories_filtered = [] 
    let menuLevel = 0;
    let selectedItem = {};
    let popup = false;
    let searchTerm = '';
    let new_category_value = '';

    
    onMount(async() => {

      getCategories();        
        
    })

    async function getCategories() {

      let postData = {};

      postData.action = 'categories2';
      postData.token = $UserStore.token
      let response = await fetchData(postData);
      if (response.success==1) {
        menuItems = response.data.merchants;   
        categories = response.data.categories;   

      }

    }

    function openCategoryBox(event) {

      console.log('categoties',event.detail)
      selectedItem = event.detail;
      popup = true;

    }

    function closePopup() {
      popup = false;
    }

    function setConnectedCat(cat) {

      if (!selectedItem.categories_connections.some(item => item.id === cat.id)) {
        selectedItem.categories_connections.push(cat); // Add the full `cat` object
      } else {
        const index = selectedItem.categories_connections.findIndex(item => item.id === cat.id);
        if (index !== -1) {
            selectedItem.categories_connections.splice(index, 1); // Remove the item at the found index
        }
      }
      selectedItem.categories_connections = selectedItem.categories_connections;
      menuItems = menuItems;
    }

    async function save() {

      let postData = {};

        postData.action = 'save_categories2';
        postData.data = menuItems
        postData.token = $UserStore.token
        let response = await fetchData(postData);
        if (response.success==1) {
          getCategories();  

        }
    }



    function filterCategories(categories, searchTerm) {
      return categories
        .map(cat => {
          // Filter children recursively
          const filteredChildren = filterCategories(cat.children || [], searchTerm);

          // Include category if it or its children match the search term
          if (cat.name.toLowerCase().includes(searchTerm.toLowerCase()) || filteredChildren.length > 0) {
            return {
              ...cat,
              children: filteredChildren
            };
          }

          // Exclude category if neither it nor its children match
          return null;
        })
        .filter(Boolean); // Remove null entries
    }

    $: {
      // Filter categories whenever searchTerm changes
      categories_filtered = filterCategories(categories, searchTerm);
    }

    


    // $: {
    //   // Filter categories based on searchTerm
    //   categories_filtered = categories.filter(cat => {
    //     return cat.name.toLowerCase().includes(searchTerm.toLowerCase());
    //   });
    // }




    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Header />
    <div class="page">

        <TopInfo />   

        <MenuItems originalMenuItems={menuItems} {menuItems} {categories} {menuLevel} on:openCategoryBox={openCategoryBox}/>

        <button class="saveButton" on:click={()=> { save() } }>save</button>

        {#if popup}
        <div class="popup">
            <div class="popup_close" on:click={closePopup}>x</div>
            <div>
              <input type="text" bind:value={searchTerm}>
            </div>
            <div class="list">
            <ul>
            {#if categories_filtered}
              {#each categories_filtered as cat} 
                <li><span class="sync_cat" on:click={setConnectedCat(cat)} class:connected={!selectedItem.categories_connections.some(item => item.id === cat.id)}>{cat.name}</span>
                {#if cat.children.length}
                  <ul>
                  {#each cat.children as cat2} 
                    <li><span class="sync_cat" on:click={setConnectedCat(cat2)} class:connected={!selectedItem.categories_connections.some(item => item.id === cat2.id)}>{cat2.name}</span>
                    {#if cat2.children.length}
                      <ul>
                      {#each cat2.children as cat3} 
                      <li><span class="sync_cat" on:click={setConnectedCat(cat3)} class:connected={!selectedItem.categories_connections.some(item => item.id === cat3.id)}>{cat3.name}</span></li>
                      {#if cat3.children.length}
                        <ul>
                        {#each cat3.children as cat4} 
                        <li><span class="sync_cat" on:click={setConnectedCat(cat4)} class:connected={!selectedItem.categories_connections.some(item => item.id === cat4.id)}>{cat4.name}</span></li>
                        {/each}
                        </ul>
                      {/if}
                      {/each}
                      </ul>
                    {/if}
                    </li>
                  {/each}
                  </ul>                  
                {/if}
                </li>
              {/each}
            {/if}
            </ul>
            </div>
        </div>
        {/if}
        
    </div>    
</div>



<style>
  .saveButton {
    position:fixed;
    bottom:20px;
    left:0;
    right:0;
    background-color:#006da8;
    padding:5px;
    width:200px;
    color:white;
    margin:auto;
    
  }
  .list {
    overflow-y: auto;
    max-height: 500px;;
  }
  .page {
    position: relative;
  }
  .popup_close {
    background-color: var(--blue-color);
    color: white;
    display: inline-block;
    padding-top: 5px;
    border-radius: 50%;
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
    height: 25px;
    text-align: center;
    line-height: 18px;
    cursor: pointer;
  }
  .popup {
    position: fixed;
    top:20px;
    padding:20px;
    right:0;
    left:0;
    margin: auto;
    width:600px;
    background-color: white;
    z-index: 1;
    box-shadow: 0 0 10px 5px rgb(227, 227, 227);
    border-radius: 10px;;
  }
  .sync_cat {
    padding:5px;
    margin: 5px;;
    background-color: rgb(205, 216, 255);
    border-radius: 2px;
    display: inline-block;
    font-size: 12px;
  }
  .connected {
    background-color: rgb(81 95 145);
    color: #fff;
  }
  ul {
    list-style: none;
    padding-left: 0;
  }

  li {
    margin-bottom: 5px;
  }

  span {
    cursor: pointer;
  }
</style>